import type { OtherParticipant } from "@/react/components/Modals/MessagingModalCompass/LeftSidebar/List/ChatRoomTypes";
import { UserImage } from "@/react/components/SettingsApp/CompassCompat/UserImage";

import { GroupUserImage } from "./GroupUserImage";

export interface AvatarProps {
  isDirect: boolean;
  otherParticipants: OtherParticipant[];
}

export const Avatar = ({ isDirect, otherParticipants }: AvatarProps) => {
  if (isDirect) {
    const [user] = otherParticipants;
    const { avatar_url: src, name, status } = user || {};
    return <UserImage src={src} name={name} status={status} size="9" />;
  }

  return (
    <GroupUserImage user1={otherParticipants[0]} user2={otherParticipants[1]} />
  );
};
